<template>
    <div class="MultiPartChart">
        <span
            v-for="section in chartData"
            :key="JSON.stringify(section)"
            class="MultiPartChart__section"
            :style="{background: section.color, width: `${section.percent}%`}"
        ></span>
    </div>
</template>
<script>
export default {
    name: 'MultiPartChart',
    props: {
        chartData: {
            type: Array,
            required: true,
        },
    },
};
</script>
<style lang="scss">
    .MultiPartChart{
        width: 100%;
        height: 0.5rem;
        display: flex;
        border-radius: 4px;
        &__section {
            &:first-child {
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
            }
            &:last-child {
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
            }
        }
    }
</style>
